<div class="qa-grid mm-page">
  <h2 class="mb-4">{{_(KEYS.GRID.PATIENTS)}}</h2>
  <div class="card mb-5">
    <div class="card-body">
      <button type="button" class="card-title mm-pane-toggle"
              (click)="isSearchCollapsed = !isSearchCollapsed"
              [attr.aria-expanded]="!isSearchCollapsed" aria-controls="patient-grid-search-fields">
        <span class="mm-pane-toggle-label">
          <i class="fa fa-search" aria-hidden="true"></i>
          <span>{{_(KEYS.GRID.SEARCH)}}</span>
        </span>
        <span class="mm-pane-toggle-icon" aria-hidden="true">
          <i class="fa" [ngClass]="{'fa-chevron-down': isSearchCollapsed, 'fa-chevron-up': !isSearchCollapsed}"></i>
        </span>
      </button>
      <div id="patient-grid-search-fields" class="card-text" [ngbCollapse]="isSearchCollapsed">
        <!-- Client search from @ngmedax/master-data -->
        <ngmedax-client-search
          [(filter)]="filter"
          [(customFilter)]="customFilter"
          (searchChange)="onFilterChange()">

          <!-- Patient-specific extra fields -->
          <div extraFields class="extra-fields-container">
            <hr class="extra-fields-divider">
            <div class="extra-fields-grid">
              <div class="search-field">
                <label>{{_(KEYS.GRID.TYPE)}}</label>
                <select class="form-control" [(ngModel)]="metaFilter.type" (change)="onFilterChange()">
                  <option value="">{{_(KEYS.GRID.TYPE_ALL)}}</option>
                  <option value="1">{{_(KEYS.GRID.TYPE_NOT_ANONYMOUS)}}</option>
                  <option value="2">{{_(KEYS.GRID.TYPE_ANONYMOUS)}}</option>
                  <option value="3">{{_(KEYS.GRID.TYPE_PSEUDONYMOUS)}}</option>
                </select>
              </div>
              <div class="search-field">
                <label>{{_(KEYS.GRID.ID)}}</label>
                <input class="form-control" [(ngModel)]="metaFilter.uid"
                       (paste)="onFilterChange()" (change)="onFilterChange()" (keydown)="onFilterChange()">
              </div>
            </div>
          </div>
        </ngmedax-client-search>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="card-title mm-pane-header" [class.mm-pane-collapsed]="isGridCollapsed">
        <div class="mm-pane-actions">
          <button class="btn btn-sm btn-success d-inline-block" (click)="onRefresh()">
              <i class="fa fa-refresh"></i>
            </button>
        </div>
        <button type="button" class="mm-pane-toggle"
                (click)="isGridCollapsed = !isGridCollapsed"
                [attr.aria-expanded]="!isGridCollapsed" aria-controls="patient-grid-results">
          <span class="mm-pane-toggle-label"><span>{{_(KEYS.GRID.PATIENTS)}}</span></span>
          <span class="mm-pane-toggle-icon" aria-hidden="true">
            <i class="fa" [ngClass]="{'fa-chevron-down': isGridCollapsed, 'fa-chevron-up': !isGridCollapsed}"></i>
          </span>
        </button>
      </div>
      <div id="patient-grid-results" class="card-text" [ngbCollapse]="isGridCollapsed">
        <div class="table-scroll-container">
        <div class="mm-table-scroll"><table class="table">
          <thead>
          <tr>
            <!-- Dynamic columns from columns array -->
            <ng-container *ngFor="let col of columns">
              <th *ngIf="isColumnVisible(col.key)"
                  [class.id-col]="col.key === 'uid'"
                  [class.qa-cursor-pointer]="col.sortField"
                  (click)="col.sortField && onSortChange(col.sortField)">
                {{getColumnLabel(col)}}
                <i *ngIf="col.sortField && sort === col.sortField && order === 'asc'" class="fa fa-arrow-up"></i>
                <i *ngIf="col.sortField && sort === col.sortField && order === 'desc'" class="fa fa-arrow-down"></i>
              </th>
            </ng-container>
            <th>{{_(KEYS.GRID.OPTIONS)}}</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let patient of getPatients(); let pos = index;">
            <tr [ngClass]="{'qa-tr-odd': pos % 2 === 0}">
              <!-- Dynamic columns -->
              <ng-container *ngFor="let col of columns">
                <ng-container *ngIf="isColumnVisible(col.key)">
                  <!-- ID -->
                  <td *ngIf="col.key === 'uid'" class="id-col">
                    <span ngbTooltip="{{patient.uid}}">{{patient.uid | truncate: 5}}</span>
                  </td>

                  <!-- Name -->
                  <td *ngIf="col.key === 'name'">
                    <ng-container *ngIf="!patient.anonymous && !patient.pseudonymous">
                      <ng-container *ngIf="patient?.pseudoId">
                        Pseudo Id - {{patient?.pseudoId}}<br>
                      </ng-container>
                      <!--
                      <span *ngIf="patient.gender === 'male'">{{_(KEYS.GRID.SALUTATION_MR)}}</span>
                      <span *ngIf="patient.gender === 'female'">{{_(KEYS.GRID.SALUTATION_MS)}}</span>
                      -->
                      {{patient.firstName}} {{patient.lastName}}
                    </ng-container>
                    <ng-container *ngIf="patient.anonymous">
                      {{_(KEYS.GRID.ANONYMOUS)}}
                    </ng-container>
                    <ng-container *ngIf="patient.pseudonymous">
                      {{_(KEYS.GRID.PSEUDONYMOUS)}}
                      <ng-container *ngIf="patient?.pseudoId">
                        <br>Pseudo Id - {{patient?.pseudoId}}
                      </ng-container>
                    </ng-container>
                  </td>

                  <!-- Address -->
                  <td *ngIf="col.key === 'address'">
                    <span>
                      <ng-container *ngIf="patient.street && patient.streetNr; else deprecated">
                        {{patient.street}} {{patient.streetNr}}<br>
                        {{patient.zipCode}} {{patient.city}}
                      </ng-container>
                      <ng-template #deprecated>
                        {{patient.address}}
                      </ng-template>
                    </span>
                  </td>

                  <!-- Location -->
                  <td *ngIf="col.key === 'location'">
                    <span ngbTooltip="{{patient.location}}">{{patient.location | truncate: 25}}</span>
                  </td>

                  <!-- Customer number -->
                  <td *ngIf="col.key === 'customerNr'">{{patient.customerNr}}</td>

                  <!-- Email -->
                  <td *ngIf="col.key === 'email'">{{patient.email}}</td>

                  <!-- Created at -->
                  <td *ngIf="col.key === 'createdAt'">{{patient.createdAt | datex:dateFormat}}</td>

                  <!-- Updated at -->
                  <td *ngIf="col.key === 'updatedAt'">{{patient.updatedAt | datex:dateFormat}}</td>

                  <!-- Created by -->
                  <td *ngIf="col.key === 'createdBy'">{{patient.createdBy}}</td>

                  <!-- Updated by -->
                  <td *ngIf="col.key === 'updatedBy'">{{patient.updatedBy}}</td>

                  <!-- Custom fields -->
                  <td *ngIf="col.isCustom">
                    <ng-container *ngIf="getCustomFieldType(col.key.replace('custom.', '')) === 'boolean'; else customText">
                      <i *ngIf="isCustomValueTrue(patient, col.key.replace('custom.', ''))" class="fa fa-check"></i>
                      <i *ngIf="!isCustomValueTrue(patient, col.key.replace('custom.', ''))" class="fa fa-times"></i>
                    </ng-container>
                    <ng-template #customText>{{getCustomValue(patient, col.key.replace('custom.', ''))}}</ng-template>
                  </td>
                </ng-container>
              </ng-container>

              <td>
                <div class="d-inline-block nowrap">
                  <div
                    class="btn btn-primary ml-1"
                    [routerLink]="'/module/patient/crud/' + patient.uid"
                    data-toggle="tooltip" data-placement="top"
                    [title]="_(KEYS.GRID.CHANGE)"
                  >
                    <i class="fa fa-edit qa-cursor-pointer"></i>
                  </div>
                  <div
                    class="btn btn-primary ml-1"
                    [routerLink]="'/module/patient/assign/' + patient.uid"
                    data-toggle="tooltip" data-placement="top"
                    [title]="_(KEYS.GRID.ASSIGN_QUESTIONNAIRES)">
                    <i class="fa fa-bars qa-cursor-pointer"></i>
                  </div>
                  <div
                    class="btn btn-danger ml-1"
                    (click)="onDeletePatient(patient)"
                    data-toggle="tooltip" data-placement="top"
                    [title]="_(KEYS.GRID.DELETE)">
                    <i class="fa fa-trash qa-cursor-pointer"></i>
                  </div>

                </div>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table></div>
        </div>
        <div class="btn-toolbar justify-content-between mt-2 mb-2">
          <div class="justify-content-between">
            <div class="input-group">
              <div class="input-group qa-num-per-page">
                <select class="form-control custom-select" [(ngModel)]="displayPerPage" (change)="onPagingChange()">
                  <option value="2">2</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span class="input-group-addon">{{_(KEYS.GRID.ENTRIES)}}</span>
              </div>

              <!-- Column selector dropdown -->
              <div class="dropdown d-flex ml-2" ngbDropdown autoClose="outside">
                <button class="btn btn-primary" ngbDropdownToggle>
                  <i class="fa fa-columns"></i> {{_(KEYS.GRID.COLUMNS)}}
                </button>
                <div ngbDropdownMenu class="column-selector-menu">
                  <ng-container *ngFor="let col of columns; let first = first">
                    <hr *ngIf="isFooterColumn(col) && !isFooterColumn(columns[columns.indexOf(col) - 1])" class="my-1">
                    <div class="dropdown-item qa-cursor-pointer d-flex align-items-center">
                      <span class="flex-grow-1" (click)="onToggleColumn(col); $event.stopPropagation()">
                        <i class="fa" [ngClass]="{'fa-check-square-o': col.visible, 'fa-square-o': !col.visible}"></i>
                        {{getColumnLabel(col)}}
                      </span>
                      <span *ngIf="!isFooterColumn(col)" class="column-order-buttons">
                        <i class="fa fa-chevron-up" (click)="onMoveColumnUp(col); $event.stopPropagation()"></i>
                        <i class="fa fa-chevron-down" (click)="onMoveColumnDown(col); $event.stopPropagation()"></i>
                      </span>
                    </div>
                  </ng-container>
                  <hr class="my-1">
                  <div class="dropdown-item qa-cursor-pointer" style="color: var(--mm-fill-accent-hover)" (click)="onResetColumns()">
                    <i class="fa fa-refresh"></i> {{_(KEYS.GRID.RESET_COLUMNS)}}
                  </div>
                  <ng-container *ngIf="canEditSettings">
                    <hr class="my-1">
                    <div class="dropdown-item qa-cursor-pointer" style="color: var(--mm-fill-accent-hover)" (click)="onSaveAsDefault()">
                      <i class="fa fa-save"></i> {{_(KEYS.GRID.SAVE_AS_DEFAULT)}}
                    </div>
                    <div class="dropdown-item qa-cursor-pointer" style="color: var(--mm-fill-accent-hover)" (click)="onResetDefault()">
                      <i class="fa fa-trash"></i> {{_(KEYS.GRID.RESET_DEFAULT)}}
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <ngb-pagination
            [pageSize]="displayPerPage"
            [maxSize]="9"
            [rotate]="true"
            [(page)]="gridPageNumber"
            [collectionSize]="total"
            (pageChange)="onPagingChange()">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
